import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { firstValueFrom } from 'rxjs';
import { AppConsts } from '../../AppConsts';
import { PeriodDto, PeriodService } from 'src/app/proxy/periods';

@Component({
  selector: 'app-period-selector',
  standalone: false,
  templateUrl: './period-selector.component.html',
})
export class PeriodSelectorComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() periodIdSelected: number | undefined;
  @Input() isDisabled = false;

  @Output() changeSelectedPeriod = new EventEmitter<PeriodDto>();
  periods: PeriodDto[];
  selectedPeriod: PeriodDto;

  constructor(
    injector: Injector,
    private readonly _periodService: PeriodService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadPeriods();
    this.onSelected();
  }

  async loadPeriods(): Promise<void> {
    try {
      this.showLoading();

      const result = await firstValueFrom(this._periodService.getAllByInput({
        maxResultCount: AppConsts.MaxPageSize,
        skipCount: 0
      }));

      this.periods = result.items;
    } finally {
      this.hideLoading();
    }
  }

  onSelected(): void {
    this.changeSelectedPeriod.emit(this.selectedPeriod);
  }

  async setSelectedPeriodById(periodId: number | undefined): Promise<void> {
    this.periodIdSelected = periodId;

    if (this.isNullOrUndefined(this.periods)) {
      await this.loadPeriods();
    }
    
    this.setSelectedPeriod();
  }

  private setSelectedPeriod(): void {
    if (this.periods?.length) {
      this.selectedPeriod = this.periods.find(x => x.id === this.periodIdSelected);
      this.onSelected();
    }
  }
}